/* eslint-disable no-console */

import Vue from 'vue'
import Router from 'vue-router'
import axios from 'axios';
import store from '@/store';
import Dashboard from './views/Dashboard.vue'
import Project from './views/Project.vue'
import ProjectNew from './views/ProjectNew.vue'
import ProjectEdit from './views/ProjectEdit.vue'

import FormHistory from './views/FormHistory.vue'

import Table from './views/Table.vue'
import TableEdit from './views/TableEdit.vue'
import TableFields from './views/TableFields.vue'

import Redirects from './views/Redirects.vue'
import RedirectsIndex from './views/RedirectsIndex.vue'
import RedirectsForm from './views/RedirectsForm.vue'


import TableBrowse from './views/TableBrowse.vue'
import PostForm from './views/PostForm.vue'

import User from './views/User.vue'

import Users from './views/Users.vue'
import UsersEdit from './views/UsersEdit.vue'


import Page from './views/Page.vue'
// import Admin from './views/Admin.vue'
import AdminBlocks from './views/admin/Blocks.vue'
import AdminTemplates from './views/admin/Templates.vue'
import AdminUsers from './views/admin/Users.vue'
import Login from './views/Login.vue'
import Forgot from './views/Forgot.vue'
import NewPassword from './views/NewPassword.vue'
import Mobile from './views/Mobile.vue'
//import store from './store'

Vue.use(Router)

const router = new Router({
  mode:'history',
  routes: [
    { path: '/', name: 'dashboard', component: Dashboard, meta: {restricted:true}, },

    { path: '/login', name: 'login', component: Login, props: true, meta: {restricted:false}, },
    { path: '/forgot', name: 'forgot', component: Forgot, props: true, meta: {restricted:false}, },
    { path: '/new-password', name: 'new-password', component: NewPassword, props: true, meta: {restricted:false}, },

    { path: '/mobile', name: 'mobile', component: Mobile, meta: {restricted:true}, },

    // { path: '/admin', name: 'admin', component: Admin, meta: {restricted:true,admin:true}, },
    { path: '/erp/blocks', name: 'admin-blocks', component: AdminBlocks, meta: {restricted:true,admin:true}, },
    { path: '/erp/templates', name: 'admin-templates', component: AdminTemplates, meta: {restricted:true,admin:true}, },
    { path: '/erp/users', name: 'admin-users', component: AdminUsers, meta: {restricted:true,admin:true}, },

	{ path: '/users', name: 'users', component: Users, meta: {restricted:true,businessAdmin:true}, },
	{ path: '/users/new', name: 'users-new', component: UsersEdit, meta: {restricted:true,businessAdmin:true}, },
	{ path: '/users/:id', name: 'users-edit', component: UsersEdit, props: true, meta: {restricted:true,businessAdmin:true}, },

    { path: '/user', name: 'user', component: User, props: false, meta: {restricted:true}, },

    { path: '/project/new', name: 'project-new', component: ProjectNew, props: false, meta: {restricted:true}, },
    { path: '/project/:id', name: 'project', component: Project, props: true, meta: {restricted:true}, },

    { path: '/project/:project_id/form-history', name: 'form-history', component: FormHistory, props: true, meta: {restricted:true}, },

    { path: '/project/:project_id/tables', name: 'project-tables', component: Table, props: true, meta: {restricted:true}, },
    { path: '/project/:project_id/table/new', name: 'project-table-new', component: TableEdit, props: true, meta: {restricted:true}, },
    { path: '/project/:project_id/table/:id', name: 'project-table-edit', component: TableEdit, props: true, meta: {restricted:true}, },

		{ path: '/project/:project_id/redirects', component: Redirects, meta: {restricted:true}, children: [
			{path: '', name: 'redirects', component: RedirectsIndex, props: false},
			{ path: 'new', name: 'redirects-form-new', component: RedirectsForm, props: false},
			{ path: 'edit/:id', name: 'redirects-form', component: RedirectsForm, props: true},
			]},


    { path: '/project/:project_id/table/:table_id/fields', name: 'project-table-fields', component: TableFields, props: true, meta: {restricted:true}, },
    { path: '/project/:project_id/table/:table_id/browse', name: 'project-table-data', component: TableBrowse, props: true, meta: {restricted:true}, },
    { path: '/project/:project_id/table/:table_id/browse/new', name: 'project-table-data-new', component: PostForm, props: true, meta: {restricted:true}, },
    { path: '/project/:project_id/table/:table_id/browse/edit/:id', name: 'project-table-data-edit', component: PostForm, props: true, meta: {restricted:true}, },


    { path: '/project/:id/edit', name: 'project-edit', component: ProjectEdit, props: true, meta: {restricted:true}, },
    { path: '/project/:id/:page_id', name: 'page', component: Page, props: true, meta: {restricted:true}, },



  ]
})


router.beforeEach((to, from, next) => {
/*  window.scrollTo(0,0); */

  console.log('route beforeeach to: ',to.path);

  if(to.path=='/logout'){

    axios({
      method: 'get',
      url: '/api/logout',
    }).then((res)=>{
      store.dispatch('setUser',{})
    }).catch((error)=>{
      console.log('error',error);
    });

    return next('/login');
  }

  if(!store.getters.isAuthenticated && to.meta.restricted){
    store.dispatch('setIntendedUrl',to.path);
    return next('/login');
  }

  next();

});

export default router
